<ng-container *transloco="let t; prefix: 'PremiseHazard'">
  <div class="list-page-table-container">
    @if (IsInitialized) {
    <div class="list-toolbar-row">
      <div class="list-toolbar-left">
        @if (showSearch) {
        <app-search-input class="list-toolbar-search" [placeholder]="'PremiseHazard.List.searchPlaceholder'"
          [ariaLabel]="'PremiseHazard.List.searchButton'" [isLoading]="!AllowInteraction && IsInitialized"
          [initialValue]="searchTerm" [isSearchActive]="isSearchActive" (searchExecuted)="executeSearch($event)"
          (searchCancelled)="cancelSearch()"></app-search-input>
        }
        <button pButton [text]="true" class="msi-padding-s refresh-button" [disabled]="!AllowInteraction"
          [attr.aria-label]="t('List.refreshButton')" [pTooltip]="t('List.refreshButton')" (click)="refreshClicked()">
          <msi-icon name="ic_refresh" /> {{ 'Buttons.refresh' | transloco }}
        </button>
        <button pButton [text]="true" class="msi-padding-s load-more-button"
          [disabled]="!HasMoreResults || !AllowInteraction" (click)="loadNextPageClicked()">
          <msi-icon [name]="AllowInteraction ? 'ic_download' : 'ic_refresh'" />{{ LoadMoreText }}
        </button>
      </div>
      <div class="list-toolbar-right">
        <!-- <button pButton [outlined]="true" class="msi-padding-s"
          [disabled]="!AllowInteraction || SelectedHazardIds.size === 0">
          <msi-icon name="ic_trash" />{{ 'Buttons.delete' | transloco }}
        </button> -->
        @if (SelectedHazardIds.size > 0) {
          {{ SelectedHazardIds.size }} / {{MaxSelectionCount}}
        }
        <button pButton [outlined]="true" class="msi-padding-s"
          [disabled]="!AllowInteraction || !CanCreateReports || SelectedHazardIds.size === 0"
          (click)="bulkDownloadClicked()" [text]="true">
          <msi-icon name="ic_download" />{{ 'Buttons.exportToPdf' | transloco }}
        </button>
        <button pButton [outlined]="true" class="msi-padding-s" [disabled]="!AllowInteraction"
          (click)="addNewClicked()">
          <msi-icon name="ic_add" />{{ 'Buttons.add' | transloco }}
        </button>
      </div>
    </div>
    @if (!AllowInteraction && IsInitialized) {
    <div class="justify-content-center">
      <p-progress-spinner size="xlarge" ariaLabel="loading" animationDuration="2s" />
    </div>
    }
    @else if (PremiseHazardRows !== undefined) {
    <div class="data-table-wrapper">
      <p-table #table class="scrolling-data-table" [value]="PremiseHazardRows" [scrollable]="true" scrollHeight="flex"
        dataKey="id" [customSort]="true" (sortFunction)="serverSideSorting($event)">
        <ng-template pTemplate="header">
          <tr style="flex: 1;">
            <th style="width: 60px;">
              <p-checkbox [ngModel]="selectAllModel" [value]="selectAllOptionValue"
                [indeterminate]="selectAllIndeterminate" [disabled]="!AllowInteraction"
                (onChange)="onSelectAllChanged()" />
            </th>
            <th style="min-width: 180px; max-width: 240px;" pSortableColumn="recordTitle" scope="col">
              {{ t('label.name') }}
              <app-sort-icon [sortDirection]="recordTitleSortDirection" [size]="14" />
            </th>
            <th style="width: 120px;" pSortableColumn="priority" scope="col">
              {{ t('label.priority') }}
              <app-sort-icon [sortDirection]="prioritySortDirection" [size]="14" />
            </th>
            <th style="min-width: 120px; max-width: 240px;" pSortableColumn="type.code" scope="col">
              {{ t('label.hazardType') }}
              <app-sort-icon [sortDirection]="typeCodeSortDirection" [size]="14" />
            </th>
            <th style="flex: 1;">
              {{ t('label.address')}}
            </th>
            <th style="min-width: 60px;"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row let-customer let-i="rowIndex">
          <tr class="hazard-row" [class.disabled-row]="!AllowInteraction"
            [class.row-selected]="SelectedHazardIds.has(row.id)" (click)="onRowClicked(row)">
            <td (click)="$event.stopPropagation()">
              <p-checkbox [id]="row.id" [binary]="true" (onChange)="onCheckboxChange($event, row.id)"
                [disabled]="PreventNewSelections && !SelectedHazardIds.has(row.id)"
                [class.disabled]="PreventNewSelections && !SelectedHazardIds.has(row.id)" />
            </td>
            <td class="record-name-cell" [appEllipsisTooltip]="row.recordTitle"
              (click)="$event.stopPropagation(); viewPremiseHazardClicked(row)">
              {{ row.recordTitle }}
            </td>
            <td [appEllipsisTooltip]="row.priority">
              {{ row.priority }}
            </td>
            <td [appEllipsisTooltip]="row.type?.code">
              @if (row.type?.code) {
              {{ row.type.code }}
              }
              @if (!row.type?.code) {
              <span class="no-type-cell">
                <msi-icon class="error_icon no-type-icon" name="ic_error" [pTooltip]="t('View.tooltip.noType')" />{{
                t('error.noType') }}
              </span>
              }
            </td>
            @if (row.address && row.address.id) {
            @if (row.address.commonPlaceName) {
            <td [appEllipsisTooltip]="row.address.commonPlaceName">
              {{ row.address.commonPlaceName }}
            </td>
            } @else {
            <td [appEllipsisTooltip]="row.address?.houseAddress">
              {{ row.address.houseAddress }}, {{ row.address.city }}, {{ row.address.state }}, {{ row.address.postalCode
              }}
            </td>
            }
            } @else {
            <td [appEllipsisTooltip]="row.address?.houseAddress">
              <msi-icon [pTooltip]="t('tooltip.noAddress')" name="ic_error" class="error_icon" />
              {{ t('View.text.noAddressError') }}
            </td>
            }
            <td class="row-actions-cell" (click)="$event.stopPropagation()">
              <div class="row-actions">
                <button pButton [text]="true" [rounded]="true" class="row-action-button"
                  [disabled]="!AllowInteraction || !CanCreateReports" [attr.aria-label]="t('List.printButton')"
                  [pTooltip]="t('List.printButton')" (click)="printToPdfClicked(row)">
                  <msi-icon name="ic_printer" />
                </button>
                <button pButton [text]="true" [rounded]="true" class="row-action-button"
                  [disabled]="!AllowInteraction || !CanEdit" [attr.aria-label]="'Buttons.delete' | transloco"
                  [pTooltip]="'Buttons.delete' | transloco" (click)="deleteClicked(row)">
                  <msi-icon name="ic_trash" />
                </button>
                <button pButton [text]="true" [rounded]="true" class="row-action-button"
                  [disabled]="!AllowInteraction || !CanEdit" [attr.aria-label]="'Buttons.edit' | transloco"
                  [pTooltip]="'Buttons.edit' | transloco" (click)="quickEditClicked(row)">
                  <msi-icon name="ic_edit" />
                </button>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    }
    }
    @if (!IsInitialized) {
    <div class="justify-content-center">
      <p-progress-spinner></p-progress-spinner>
    </div>
    }
  </div>
</ng-container>